import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector} from 'react-redux';

import { Container, Title, TitleRow, User, Button, NoItems, UserIcon, UserName, Invites, NumOf, Label } from './FriendsList.styles';
import T, { Translate } from '../../i18n/i18n';
import { getFriends, acceptFriendRequest, cancelFriendRequest } from '../../../services/friends';
import { profilesActions, rtcBufferActions } from '../../../redux/actions';

export default () => {

    const history = useHistory();
    const dispatch = useDispatch();

    const userId = useSelector(state => state.authState.id);
    const lastUpdateFriendList = useSelector(state => state.profilesState.updateFriendlist);

    const [expanded, setExpanded] = useState(localStorage.getItem('config.profileFriendsExpand') === '1');
    const [total, setTotal] = useState(0);
    const [friends, setFriends] = useState([]);
    const [pending, setPending] = useState([]);

    const goToFriendsPage = () => {
        history.push('/home/friends');
    }

    const handleOpenProfile = (id) => {
        dispatch(profilesActions.setMessage("",""));
        history.push(`/home/user/${id}`)
    }

    const handleAcceptRequest = async (e, id, email) => {
        e.stopPropagation();
        e.preventDefault();

        let res = await acceptFriendRequest(id);
        if (res.status === 'ok') {
            dispatch(profilesActions.setMessage(Translate("friends.accepted"),"ok"));
            dispatch(rtcBufferActions.pushOutputBuffer({
                type: 'frienListUpdate',
                to: email,
                data: JSON.stringify({friend:id, user: userId})
            }));
            dispatch(profilesActions.setUpdateFriendlist());
        } else {
            dispatch(profilesActions.setMessage(res.message,"error"));
            history.push(`/home/friends`);
        }
    };

    const handleRejectRequest = async (e, id) => {
        e.stopPropagation();
        e.preventDefault();

        let res = await cancelFriendRequest(id);
        if (res.status === 'ok') {
            dispatch(profilesActions.setMessage(Translate("friends.removed"),"ok"));
            let f = (res.payload ? res.payload.friends : []) ?? [];
            let p = (res.payload ? res.payload.pending : []) ?? [];
            setFriends(f);
            setPending(p);
        } else {
            dispatch(profilesActions.setMessage(res.message,"error"));
            history.push(`/home/friends`);
        }
    };

    const handleExpand = () => {
        setExpanded(e => {
            localStorage.setItem('config.profileFriendsExpand', !e ? '1' : '0');
            return !e;
        })
    }

    useEffect(() => {
        let setList = true;
        let timer = null;

        if (lastUpdateFriendList) {
            const fn = (async () => {
                let friends = await getFriends()
                if (setList) {
                    let t = (friends.payload ? friends.payload.total : 0) ?? 0;
                    let f = (friends.payload ? friends.payload.friends : []) ?? [];
                    let p = (friends.payload ? friends.payload.pending : []) ?? [];
                    setTotal(t);
                    setFriends(f);
                    setPending(p);
                }
            });

            fn();
            timer = setInterval(()=>fn(), 60000);
        }

        return () => {
            setList = false;
            clearInterval(timer);
        }
    }, [lastUpdateFriendList]);
    

    return <Container>
        <TitleRow onClick={()=>{handleExpand()}} className={expanded ? 'expanded' : ''}>
            <Title><T value="friends.title" /></Title>    
            {!expanded ? <NumOf>Online ({friends.length}/{total})</NumOf> : null}
            {expanded ? <Button color="#be5cde" title={Translate("friends.seeAll")} icon={'\\F0849'} onClick={goToFriendsPage} /> : null }
        </TitleRow>
        { expanded ? <>
            { pending.length ? <>
                <Label><T value="friends.pending" /></Label>
                {pending.map(p => <User key={p.id} onClick={()=>handleOpenProfile(f.id)}>
                    <UserIcon color={p.color} fgColor={p.fgColor}>{p.name ? p.name.substr(0,1) : ""}</UserIcon>
                    <UserName>{p.name}</UserName>
                    <Invites>
                        <Button color="#0c0" className={'compact'} title={Translate("friends.accept")} onClick={(e)=>{handleAcceptRequest(e, p.id, p.email)}} icon={'\\F012C'} />
                        <Button color="#f33" className={'compact'} title={Translate("friends.refuse")} onClick={(e)=>{handleRejectRequest(e, p.id)}} icon={'\\F0156'} />
                    </Invites>
                </User>)}
                { friends.length ? <Label><T value="friends.online" /></Label> : null }
            </> : null}
            { friends.length ? friends.map(f => <User key={f.id} onClick={()=>handleOpenProfile(f.id)}>
                <UserIcon color={f.color} fgColor={f.fgColor}>{f.name ? f.name.substr(0,1) : ""}</UserIcon>
                <UserName>{f.name}</UserName>
            </User>) : null}
            { !friends.length && !pending.length ? <NoItems>
                <T value="friends.noFriends1" />
                <div dangerouslySetInnerHTML={{__html: Translate("friends.noFriends2")}} />
            </NoItems> : null}
        </> : null }
    </Container>
};